import constants from './constants';
export default function createSubjectId(productId, ruleCode) {
  return ruleCode ? "".concat(ruleCode).concat(constants.INDIRECT_SUBJECT_SEPARATOR).concat(productId) : productId;
}